import React, { useState, useEffect } from 'react';
import marked from 'marked';
import '../styles/MarkdownPost.css';

const MarkdownPost = ({ postUrl, title, onBack }) => {
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchMarkdown = async () => {
            try {
                setLoading(true);
                const response = await fetch(postUrl);
                if (!response.ok) {
                    throw new Error(`Failed to fetch post: ${response.status}`);
                }
                const markdownText = await response.text();
                
                // Configure marked options for better rendering
                marked.setOptions({
                    breaks: true,
                    gfm: true,
                    headerIds: true,
                    mangle: false,
                    sanitize: false
                });

                const htmlContent = marked.parse(markdownText);
                setContent(htmlContent);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (postUrl) {
            fetchMarkdown();
        }
    }, [postUrl]);

    if (loading) {
        return (
            <div className="markdown-post">
                <div className="post-header">
                    <button className="back-button" onClick={onBack}>
                        ← Back to Blog
                    </button>
                </div>
                <div className="loading-container">
                    <div className="loading-spinner"></div>
                    <p>Loading post...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="markdown-post">
                <div className="post-header">
                    <button className="back-button" onClick={onBack}>
                        ← Back to Blog
                    </button>
                </div>
                <div className="error-container">
                    <h2>Error Loading Post</h2>
                    <p>{error}</p>
                    <button className="retry-button" onClick={() => window.location.reload()}>
                        Try Again
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="markdown-post">
            <div className="post-header">
                <button className="back-button" onClick={onBack}>
                    ← Back to Blog
                </button>
                <h1 className="post-title">{title}</h1>
            </div>
            <div className="post-content">
                <div 
                    className="markdown-content"
                    dangerouslySetInnerHTML={{ __html: content }}
                />
            </div>
        </div>
    );
};

export default MarkdownPost;
